export default __webpack_public_path__ + "static/media/LibreBaskerville-Regular.a27f99ca.ttf";